import { useMutation } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";

export const useRecoveryEmail = () => {
  const { authHeader } = useAuth();

  return useMutation((email: string) => {
    return axios.post(
      `${env.verifyServiceUrl}user/two_factor/recover/recovery_email/`,
      { email: email },
      {
        headers: {
          Authorization: authHeader,
        },
      }
    );
  });
};
